import { Outlet } from 'react-router-dom';

import SideNav from 'components/SideNav/SideNav';
import './RootLayout.scss';
import { Nav } from 'components/Nav';

const RootLayout = () => {
  return (
    <div className="root-layout">
      {/* <SideNav /> */}
      <header>
        <Nav />
      </header>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};

export default RootLayout;
